module.exports = __webpack_public_path__ + "img/ug345.efcd8ca8.png";